import { render } from "./order_received.vue?vue&type=template&id=3a3f463c"
import script from "./order_received.vue?vue&type=script&lang=js"
export * from "./order_received.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__